export const Menu = {
  baseStyle: {
    list: {
      zIndex: 9999,
    },
  },
};
